import * as constants from '@/constants'

export const getAllowedLanguages = storeAllowedLanguages => {
  if (!storeAllowedLanguages) {
    return constants.allowedLanguages
  }

  return constants.allowedLanguages.filter(language => storeAllowedLanguages?.includes(language.value))
}
